import { Card, CardHeader, CardText } from "material-ui/Card";
import Chip from "material-ui/Chip";
import React, { Component } from "react";

import "./timeline.css";

const style1 = {
  background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
  borderRadius: 3,
  border: 0,
  color: "white",
  // height: 48,
  padding: "0 30px",
  boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
  maxHeight: 500,
  overflow: "auto"
};

const style2 = {
  background: "linear-gradient(45deg, #43cea2 30%, #185a9d 90%)",
  borderRadius: 3,
  border: 0,
  color: "white",
  // height: 48,
  padding: "0 30px",
  boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
  maxHeight: 500,
  overflow: "auto"
};

class TimelineComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded1: false,
      expanded2: false,
      expanded3: false
    };
  }

  async componentDidMount() {}

  componentWillUnmount() {}

  handleExpandChange = expanded1 => {
    this.setState({ expanded1: expanded1 });
  };

  handleExpandChange2 = expanded2 => {
    this.setState({ expanded2: expanded2 });
  };

  handleExpandChange3 = expanded3 => {
    this.setState({ expanded3: expanded3 });
  };

  handleExpand = () => {
    this.setState({ expanded: true });
  };

  handleExpand2 = () => {
    this.setState({ expanded2: true });
  };

  handleExpand3 = () => {
    this.setState({ expanded3: true });
  };

  handleReduce = () => {
    this.setState({ expanded1: false });
  };

  handleReduce2 = () => {
    this.setState({ expanded2: false });
  };

  handleReduce3 = () => {
    this.setState({ expanded3: false });
  };
  render() {
    return (
      <div className="tLine">
        <p className="headline">Working experience</p>
        <div className="tLine-entry">
          <Card style={style1}>
            <CardHeader
              title="Subcontractor Digitalization"
              subtitle="John Holland Group"
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true}>
              December 2018 – March 2019.
              <ul
                style={{
                  "list-style-type": "disc",
                  color: "black",
                  "text-align": "justify"
                }}
              >
                <li>
                  Developed a web application called Docket Management Systems
                  (DMS) in ReactJS using JSX and SASS technologies and powered
                  by cloud technology of Google Firebase. DMS helps eliminate
                  manual collection and to streamline site data throughout
                  project lifecycle while delivering enhanced efficiency,
                  productivity and communication across multiple business units.
                  Subsequently, DMS maximizes the time savings for multiple
                  stakeholders of the alliance projects, and placates problems
                  resulting from the paper trail.
                </li>
                <li>
                  Implement a digital solution which captures and analyses
                  important construction data in realtime. This digital tool
                  enhances work performance for all employees on NWPA. Further
                  this tool can be used on the Alliance for the life span of an
                  entire project and potentially on other projects and by
                  constructions companies.
                </li>
                <li>
                  Conducted research on paper trails, and other opportunities to
                  identify potential digitizable areas.
                </li>
                <li>
                  Learnt legacy software systems, business architecture, and
                  linkages.
                </li>
                <li>
                  Designed few power apps for focus groups and general use of
                  organization, respectively.
                </li>
                <li>
                  Adopted SharePoint and Teams considering business requirement,
                  budget, tool capability and scalability.
                </li>
                <li>
                  Authored several important documents with regards to the
                  application created. This includes but is not limited to,
                  Handover plan, Implementation Plan, Business Case, Cost
                  Benefit Analysis, Score Card, SIPOC, and Process Map.
                </li>
                <li>
                  Created Animated Video Presentation for the Project with
                  custom created sound affects using Adobe After Effects, Adobe
                  Illustrator and FL Studio.
                </li>
                <li>
                  Investigate data through advanced queries and quantitative
                  analysis to provide solutions for cross-functional teams in
                  alliance.
                </li>
              </ul>
              <br />
              <br />
              <div className="tLine-entries">
                <div className="tLine-entry-chip">
                  <Chip>ReactJS 16.7</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>Firebase</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>Adobe After Effects, Adobe Illustrator</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>FL Studio</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>SASS</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>Foundation, Bootstrap</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>Trello</Chip>
                </div>
              </div>
            </CardText>
          </Card>
        </div>
        <div className="tLine-entry">
          <Card
            style={style2}
            expanded={this.state.expanded1}
            onExpandChange={this.handleExpandChange}
          >
            <CardHeader
              title="Data Science Consultant"
              subtitle="AltairQ"
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true}>
              November 2018 – current.
              <ul
                style={{
                  "list-style-type": "disc",
                  color: "black",
                  "text-align": "justify"
                }}
              >
                <li>
                  Exploratory Data Analysis in the domain of natural language
                  processing (NLP) and Image Classification.
                </li>
                <li>Model building, inference and prediction.</li>
                <li>
                  Designed and deployed analytics requirements, approach, and
                  tools.
                </li>
                <li>
                  Semantic extraction, sentiment analysis and relational
                  clustering were used to identify key areas for customer
                  support improvement.
                </li>
                <li>
                  Image Augmentation techniques were used for data enhancement.
                </li>
                <li>
                  Cost Benefit Analysis (CBA) of databases for the research
                  project.
                </li>
                <li>Database design, Querying and management in MongoDB.</li>
                <li>
                  Data Munging and techniques of OCR and Neural Networks were
                  used to capture and transform data from unstructured and semi-
                  structured documents to that of a structure in JSON to
                  facilitate dump in database.
                </li>
                <li>
                  Built a lightweight data warehousing solution with data
                  storage and custom ETL features, using ReactJS and Google
                  Firebase Firestore.
                </li>
              </ul>
              <br />
              <br />
              <div className="tLine-entries">
                <div className="tLine-entry-chip">
                  <Chip>Python</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>R</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>Tensorflow</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>Google Colab</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>Keras</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>NLP</Chip>
                </div>
                <div className="tLine-entry-chip">
                  <Chip>Image Classification</Chip>
                </div>
              </div>
            </CardText>
          </Card>
        </div>
        <div className="tLine-entry">
          <Card
            style={style1}
            expanded={this.state.expanded2}
            onExpandChange={this.handleExpandChange2}
          >
            <CardHeader
              title="Industry Analyst"
              subtitle="Overseas Investors’ Chamber of Commerce & Industry"
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true}>
              August 2016 – May 2017.
              <ul
                style={{
                  "list-style-type": "disc",
                  color: "black",
                  "text-align": "justify"
                }}
              >
                <li>
                  Working on Ethics Committee Project to encourage ethical
                  marketing practices initially among member companies and
                  eventually all pharmaceutical companies in Pakistan; also
                  working on the projects of Hardships and Counterfeiting Drug
                  Industry.
                </li>
                <li>
                  Working with Regulatory Committee to bring about
                  implementation of fair pricing policy inharmony with CPI for
                  all pharmaceutical products and companies.
                </li>
                <li>
                  Analyse monthly review on price indices, economic activity and
                  pharmaceutical market performance and then commenting on
                  overall performance and consequences of activities in
                  pharmaceutical industry.
                </li>
                <li>
                  Communicate with cross-functional groups managing fluent flow
                  of information and feedback with the authorities from member
                  companies with regards to meetings and other professional
                  interaction.
                </li>
                <li>
                  Worked on reformatting and producing Pharma Bureau newsletter,
                  presentations, articles and reports.
                </li>
                <li>
                  Provide customized in-depth researches and consulting services
                  based on the requests from clients.
                </li>
                <li>
                  Changing the image of Pharma Bureau to that of an active
                  member and contributor to the health industry.
                </li>
              </ul>
            </CardText>
          </Card>
        </div>
        <div className="tLine-entry">
          <Card
            style={style2}
            expanded={this.state.expanded3}
            onExpandChange={this.handleExpandChange3}
          >
            <CardHeader
              title="Research and Business Development Intern"
              subtitle="Arif Habib Commodities"
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true}>
              July 2015 – August 2015.
              <ul
                style={{
                  "list-style-type": "disc",
                  color: "black",
                  "text-align": "justify"
                }}
              >
                <li>
                  Crafted industry overview reports, including statistical and
                  market trends, to track the growth of commodities market.
                </li>
                <li>
                  Undertook study to predict patterns in volatile market; also
                  guide clientele to diversify risks efficiently and achieve
                  overall profits in long run.
                </li>
                <li>
                  Worked to market products and services of the firm and
                  generating innovative new products to be launched in the
                  market.
                </li>
              </ul>
            </CardText>
          </Card>
        </div>
      </div>
    );
  }
}

export default TimelineComponent;
